var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-upload',{attrs:{"fileList":_vm.fileList,"multiple":true,"listType":"text","customRequest":_vm.customRequest},on:{"change":_vm.onChange}},[_c('a-button',{attrs:{"icon":"upload"}},[_vm._v(_vm._s(_vm.$t("上传")))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }